import React from 'react'
import { IconProps } from '../../../common/types'

const ChevronRight: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M6 3.80176L10.6667 8.46842L6 13.1351"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronRight
